export default "__VITE_ASSET__BbE1qZdY__"